import { render, staticRenderFns } from "./ThreeBas.vue?vue&type=template&id=1b45fa83&"
import script from "./ThreeBas.vue?vue&type=script&lang=js&"
export * from "./ThreeBas.vue?vue&type=script&lang=js&"
import style0 from "./ThreeBas.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports